import React, { useState, useEffect } from "react";
import "./OurTeam.css";

const team = [
  {
    name: "Bhuvaneshwari",
    role: "Employee",
    img: "/images/woman.png",
    text: "Being part of the AERLIS Gro has been more than just a job — it’s been a journey of purpose and personal growth. Unlike traditional roles, working in an Insurance Marketing Firm allows you to make a real impact by helping individuals and families secure their future financially. It’s a high-trust, high-responsibility environment that sharpens your people skills, financial awareness, and problem-solving abilities. The best part is the entrepreneurial freedom — you’re encouraged to build your own client base, lead from the front, and grow your income without limits. Every policy sold isn’t just a sale, but a life protected, and that gives deeper meaning to the work we do every day."
  },
  {
    name: "Anitha",
    role: "Employee",
    img: "/images/woman.png",
    text: "Working in the insurance and loan sector has been a powerful and fulfilling journey. It’s a field where every conversation matters — whether I’m helping a family secure their future through insurance or guiding a customer toward a loan that supports their dreams. The mix of financial responsibility, client trust, and real-life impact makes the work meaningful. I’ve gained valuable skills in communication, financial advising, and relationship building, all while working in a fast-paced, target-driven environment that constantly pushes me to grow. It’s not just a job — it’s a career that evolves with you and rewards those who lead with honesty and passion."
  },
  {
    name: "Shanmugapriya",
    role: "Employee",
    img: "/images/woman.png",
    text: "Being part of AERLIS Gro has been an inspiring journey of learning, leadership, and growth. The company’s dynamic environment encourages fresh ideas, values individual contributions, and constantly pushes you to become the best version of yourself. What makes AERLIS Gro stand out is its balance between a performance-driven culture and a people-first approach — where every achievement is celebrated, and every challenge is seen as an opportunity. The leadership is approachable, the team spirit is strong, and the exposure across insurance, loans, and customer service has shaped me into a more confident, capable, and future-ready professional."
  },
  {
    name: "Roopan",
    role: "Employee",
    img: "/images/profile.png",
    text: "Joining AERLIS Gro has been a game-changer in my career. It’s not just a workplace — it’s a platform where talent is recognized, ideas are heard, and growth is truly earned. From day one, I was empowered with responsibilities that challenged me, trained by mentors who believed in my potential, and supported by a team that felt more like a family. The exposure to both the insurance and loan verticals helped me build strong client relationships and sharpen my problem-solving skills. At AERLIS Gro, I’m not just growing professionally — I’m evolving personally with every step."
  },
  {
    name: "Sumithra",
    role: "Employee",
    img: "/images/woman.png",
    text: "Working at AERLIS Gro has redefined what a meaningful career looks like. It's a space where ambition meets opportunity — where I’ve been trusted with real responsibilities, encouraged to think beyond targets, and supported in every challenge. The blend of financial services across insurance and loans has given me a strong foundation in client handling, financial advising, and ethical sales. What truly sets AERLIS Gro apart is its culture — fast-paced yet collaborative, professional yet people-centric. Every day here adds value not just to my resume, but to my personal and professional identity."
  }
];

export default function OurTeam() {

  const getVisible = () => (window.innerWidth <= 600 ? 1 : 3);
  const [VISIBLE, setVISIBLE] = useState(getVisible());

  const [index, setIndex] = useState(VISIBLE);
  const [animate, setAnimate] = useState(true);

  const slides = [
    ...team.slice(-VISIBLE),
    ...team,
    ...team.slice(0, VISIBLE)
  ];

  const next = () => {
    setAnimate(true);
    setIndex((i) => i + 1);
  };

  const prev = () => {
    setAnimate(true);
    setIndex((i) => i - 1);
  };

  useEffect(() => {
    const onResize = () => setVISIBLE(getVisible());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (index >= team.length + VISIBLE) {
      setTimeout(() => {
        setAnimate(false);
        setIndex(VISIBLE);
      }, 500);
    }
    if (index < VISIBLE) {
      setTimeout(() => {
        setAnimate(false);
        setIndex(team.length + VISIBLE - 1);
      }, 500);
    }
  }, [index, VISIBLE]);

  return (
    <section className="team-section">

      <div
        className="team-bg"
        style={{ backgroundImage: "url(/images/mmm.jpg)" }}
      />

      <div className="team-content">
        <h2 className="team-title">Our Team</h2>
        <p className="team-sub">
         Behind every policy and consultation is a dedicated team of professionals, passionate about helping clients safeguard their futures.
        </p>

        <div className="slider-wrapper">

          {/* DESKTOP PREV */}
          <button className="nav-btn" onClick={prev}>‹</button>

          {/* MOBILE PREV */}
          <button className="mobile-nav mobile-prev" onClick={prev}>‹</button>

          <div className="team-slider">
            <div
              className={`team-track ${animate ? "animate" : ""}`}
              style={{
                transform: `translateX(-${index * (100 / VISIBLE)}%)`
              }}
            >
              {slides.map((m, i) => (
                <div className="team-card" key={i}>
                  <img src={m.img} alt={m.name} className="team-img" />
                  <h3>{m.name}</h3>
                  <span>{m.role}</span>
                  <p>{m.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* DESKTOP NEXT */}
          <button className="nav-btn" onClick={next}>›</button>

          {/* MOBILE NEXT */}
          <button className="mobile-nav mobile-next" onClick={next}>›</button>

        </div>
      </div>
    </section>
  );
}
